// This file is automatically generated by scripts/build-corejs3-shipped-proposals.mjs

export default new Set<string>([
  "esnext.array.group",
  "esnext.array.group-to-map",
  "esnext.iterator.zip",
  "esnext.iterator.zip-keyed",
  "esnext.symbol.metadata",
]);
